import {constants} from '@neosvoc/nv-platform-core-common';

/* eslint-disable max-len */
const generateBackground = (backgroundColor) => `
body, .progress .progress-bar {background-color:${backgroundColor}}
`;

const generatePrimary = (primaryColor) => (`
::selection {background:${primaryColor}}

.btn.btn-primary {background-color:${primaryColor};border-color:${primaryColor}}
.slider-tooltip .rc-tooltip-inner {background-color:${primaryColor}}
.slider .rc-slider-track, .interval-slider .rc-slider-track, .slider .rc-slider-handle, .interval-slider .rc-slider-handle,
.slider .rc-slider-dot-active, .interval-slider .rc-slider-dot-active {background-color:${primaryColor}}
.slider-tooltip .rc-tooltip-arrow {border-top-color:${primaryColor}}
.slider .label.active, .interval-slider .label.active {color:${primaryColor}}
.interval-slider .rc-slider-mark .rc-slider-mark-text.rc-slider-mark-text-active {color:${primaryColor}}
.interval-slider .rc-slider-mark .rc-slider-mark-text.rc-slider-mark-text-active .dot {background-color:${primaryColor}}

.custom-radio .custom-control-input:checked~.custom-control-label::before {background-color:${primaryColor};border-color:${primaryColor}}
.custom-radio .custom-control-input:checked~.custom-control-label::after {border-color:${primaryColor}}
.custom-checkbox .custom-control-input:checked~.custom-control-label::before {border-color:${primaryColor}}
.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23${primaryColor.substring(1)}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
}
.content-static-image-gallery .singlechoice-img-selected {
    border: 2px solid ${primaryColor};
}
`);

const generateSecondary = (secondaryColor) => `
.progress {background:${secondaryColor}}

.btn.btn-primary:not(:disabled):not(.disabled):hover, .btn.btn-primary:not(:disabled):not(.disabled):active {
    background-color:${secondaryColor};border-color:${secondaryColor};
}
`;

const generateSuccessColor = (successColor) => `
.terminal-mark span {color:${successColor};border-color:${successColor}}
`;

const getLocalUrl = (fontName) => `/public/fonts/${encodeURIComponent(fontName)}.css`;
const getGoogleUrl = (fontName) => `https://fonts.googleapis.com/css?family=${encodeURIComponent(fontName)}:400,700`;
const fonts = {
    [constants.BRANDING_FONTS.WORK_SANS]: null, // default font
    [constants.BRANDING_FONTS.ROBOTO]: {name: 'Roboto', url: getGoogleUrl('Roboto')},
    [constants.BRANDING_FONTS.OSWALD]: {name: 'Oswald', url: getGoogleUrl('Oswald')},
    [constants.BRANDING_FONTS.LORA]: {name: 'Lora', url: getGoogleUrl('Lora')},
    [constants.BRANDING_FONTS.LOBSTER_TWO]: {name: 'Lobster Two', url: getGoogleUrl('Lobster Two')},
    [constants.BRANDING_FONTS.KALAM]: {name: 'Kalam', url: getGoogleUrl('Kalam')},
    [constants.BRANDING_FONTS.ALBERT]: {name: 'FSAlbertWeb', url: getLocalUrl('FSAlbertWeb')},
};

const generateFont = (font) => {
    if (!fonts[font]) {
        return null;
    }
    const {name, url} = fonts[font];

    return `@import url('${url}');

html, body {
    font-family: '${name}', 'Work Sans', sans-serif;
}`;
};

export default function generateStyle({backgroundColor, primaryColor, secondaryColor, successColor, font}) {
    return [
        (font && generateFont(font) || null),
        (backgroundColor && generateBackground(backgroundColor) || null),
        (primaryColor && generatePrimary(primaryColor) || null),
        (secondaryColor && generateSecondary(secondaryColor) || null),
        (successColor && generateSuccessColor(successColor) || null),
    ].filter((x) => x !== null).join('\n');
}
